module.exports = __webpack_public_path__ + "img/signup-bg2.99bcbf0e.png";